import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F4F7FB\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D1D9E5\" d=\"M20.731 19.019a4.45 4.45 0 0 0-1.848-.854l-3.29-.66A.744.744 0 0 1 15 16.77v-.855c3.277-.313 3.75-.982 3.75-1.665 0-2.017-1.341-6.702-1.562-7.464-.028-1.177-.243-1.839-.781-2.42-.381-.412-.942-.508-1.394-.584-.177-.032-.421-.073-.511-.122A5.3 5.3 0 0 0 11.968 3c-1.975.081-4.404 1.338-5.235 3.636-.06.215-1.483 5.288-1.483 7.614 0 .97 1.096 1.482 3.75 1.716v.804c0 .358-.25.668-.597.735l-3.293.66a4.5 4.5 0 0 0-1.842.852.756.756 0 0 0-.088 1.092A11.91 11.91 0 0 0 12 24a11.9 11.9 0 0 0 8.82-3.891.747.747 0 0 0-.089-1.09\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }